import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APIConstants } from '../../../../_config/restapis';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { logger } from '../../../../_helpers/Logger/Logger.class';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ErrModalData, PromptModalData, SuccModalData, ModalData } from '../../../../_helpers/Modals/ModalData';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';

@Injectable()
export class APILoginService {

    constructor(
        private http: HttpClient,
        private $modal: $ModalManagerService,
		private modal: BsModalService,
		private db:$DBManagerService

    ) { }


    public getcategory(): Observable<any> {
        return this.http.get(APIConstants.GETCATEGORY)
            .pipe(
                map((res) => this.parseResponse(res)),
                catchError(this.HandleError())
            );
    }

    public login(data): Observable<any> {
		
	//console.log("login service data:"+JSON.stringify(data));
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');

       // let b =  this.http.post<any>(APIConstants.AUTHENTICATE, { emailId: emailId, password: password })
        let a= this.http.post<any>(APIConstants.LOGINMONGO, data, { headers });
        //let a= this.http.post(APIConstants.LOGINMONGO, data, { headers });
        return a;
       
    }
	
	public verifyOtpFP(data, data1): Observable<any>{ 
	
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        let b= this.http.post(APIConstants.VERIFYOTPFP, {"otp":data,"emailId":data1}, {headers});
		return b;             
    }

	// public generateOtpFP(data): Observable<any>{
	
	// 	const headers = new HttpHeaders();
	// 	headers.set('content-type', null);
    //     headers.set('Accept', 'multipart/form-data');
    //     let b= this.http.post(APIConstants.GENERATEOTPFORGOTPASSWORD, {"emailId":data}, {headers});
	// 	return b;
    // }

    public updatePassword(data,data1): Observable<any>{
	
		const headers = new HttpHeaders();
		headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        let b= this.http.post(APIConstants.UPDATEPASSWORD, {"emailId":data,"pwd":data1}, {headers});
        return b;
    }
       
    public entityRegistration(data): Observable<any> {

        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');

        return this.http.post(APIConstants.ENTITYREGISTER, data, { headers });
    }
    
    public entityRegistrationNotification(data: any): Observable<any> {

        return this.http.post(APIConstants.ENTITYREGISTERNOTIFICATION, data);
    }

    public otpNotification(data: any): Observable<any> {

        return this.http.post(APIConstants.OTPNOTIFICATION, data);
    }

    public updateEntityDetails(data): Observable<any> {

        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');

        return this.http.post(APIConstants.UPDATEENTITYDETAILSMONGO, data, { headers });
    }
       
    // public generateOtp(data): Observable<any> {
		
	// //	console.log("data:"+JSON.stringify(data));
    //     const headers = new HttpHeaders();
    //     headers.set('content-type', null);
    //     headers.set('Accept', 'multipart/form-data');

    //     let b= this.http.post(APIConstants.GENERATEOTP, data, { headers });
    //     return b;
       
    // }

    
    // public verifyOtp(data): Observable<any> {
		
	// //console.log("data:"+JSON.stringify(data));
    //     const headers = new HttpHeaders();
    //     headers.set('content-type', null);
    //     headers.set('Accept', 'multipart/form-data');

        
    //     let b= this.http.post(APIConstants.VERIFYOTP, data, { headers });
    //     return b;
       
    // }
   
   
        // for entity generate and verify otp
    // public generateOtpEntity(data): Observable<any> {
		
	// //	console.log("data:"+JSON.stringify(data));
    //     const headers = new HttpHeaders();
    //     headers.set('content-type', null);
    //     headers.set('Accept', 'multipart/form-data');

    //     let b= this.http.post(APIConstants.GENERATEOTPENTITY, data, { headers });
    //     return b;
       
    // }
	//    public verifyOtpEntity(data): Observable<any> {
		
    // //console.log("data:"+JSON.stringify(data));
    // let userid = this.db.get(Constants.SESSSION_STORAGE, Constants.USERID_OTP);
    
    //     const headers = new HttpHeaders();
    //     headers.set('content-type', null);
    //     headers.set('Accept', 'multipart/form-data');
    //     headers.set('user_sid',userid)

        
    //     let b= this.http.post(APIConstants.VERIFYOTPENTITY, data, { headers });
    //     return b;
       
    // }
	
    private HandleError(): any {

    }
	
	public send_OTP(data): Observable<any>{             
	
        let b= this.http.post(APIConstants.SENDOPT,{"mobile":data});      
		return b;
    }
	

    private parseResponse(res): any {
        const _modRes = [];

        for (let i = 0; i < res.length; i++) {
            const obj = res[i];
            if (Object.keys(obj.Record).length < 3) {
                obj['child'] = [];
                for (let j = 0; j < res.length; j++) {
                    const elm = res[j].Record.PrefcatID;
                    if (obj.Key === elm && Object.keys(res[j].Record).length > 2) {
                        obj.child.push(res[j]);
                    }
                }
                _modRes.push(obj);
            }
        }
        return _modRes;
    }
    public ContentEntityRegistration(data): Observable<any> {   
    
        return this.http.post(APIConstants.CONTENTENTITYREGISTRATION, data);
    }



    //Phase I entity
    public generateOtpFP(data): Observable<any>{                
        const headers = new HttpHeaders();
        headers.set('content-type', null); 
         headers.set('Accept', 'multipart/form-data');
         let b= this.http.post(APIConstants.GENERATEOTPFORGOTPASSWORD, data, {headers});
        return b;
            }
			
			
			
            public loginTMPE(data): Observable<any> {
                //console.log("login service data:"+JSON.stringify(data));
                const headers = new HttpHeaders();
                headers.set('content-type', 'appliccation/json');
                
				headers.set('Access-Control-Allow-Origin', '*');
                headers.set('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
                headers.set('Accept', 'application/json');
                console.log("CALLED")
                // let b =  this.http.post<any>(APIConstants.AUTHENTICATE, { emailId: emailId, password: password })
                let a = this.http.post<any>(APIConstants.LOGINMONGOTMPE, data, { headers });
                //let a= this.http.post(APIConstants.LOGINMONGO, data, { headers });
                return a;
            }
        
        public commonLoginTmPe(data): Observable<any> {
                const headers = new HttpHeaders();
                 headers.set('content-type', 'application/json');
                
				headers.set('Access-Control-Allow-Origin', '*');
                headers.set('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
                headers.set('Accept', 'application/json');
                let b = this.http.post(APIConstants.COMMONLOGINTMPE, data, { headers });
                return b;
            }
        public generateOtp(data): Observable<any> {
                //	console.log("data:"+JSON.stringify(data));
                const headers = new HttpHeaders();
                headers.set('content-type', null);
                headers.set('Accept', 'multipart/form-data');
                let b = this.http.post(APIConstants.GENERATEOTP, data, { headers });
                return b;
            }
        
        public generateOtpEntity(data): Observable<any> {
                //	console.log("data:"+JSON.stringify(data));
                const headers = new HttpHeaders();
                headers.set('content-type', null);
                headers.set('Accept', 'multipart/form-data');
                let b = this.http.post(APIConstants.GENERATEOTPENTITY, data, { headers });
                return b;
            }
        
        public verifyOtp(data): Observable<any> {
                //console.log("data:"+JSON.stringify(data));
                const headers = new HttpHeaders();
                headers.set('content-type', null);
                headers.set('Accept', 'multipart/form-data');
                let b = this.http.post(APIConstants.VERIFYOTP, data, { headers });
                return b;
            }
        
        public verifyOtpEntity(data): Observable<any> {
                //console.log("data:"+JSON.stringify(data));
                let userid = this.db.get(Constants.SESSSION_STORAGE, Constants.USERID_OTP);
                const headers = new HttpHeaders();
                headers.set('content-type', null);
                headers.set('Accept', 'multipart/form-data');
                headers.set('user_sid', userid)
                let b = this.http.post(APIConstants.VERIFYOTPENTITY, data, { headers });
                return b;
            } 
        
        public verifyOtpEntityTMPE(data): Observable<any> {
                //console.log("data:"+JSON.stringify(data));
                let userid = this.db.get(Constants.SESSSION_STORAGE, Constants.USERID_OTP);
                const headers = new HttpHeaders();
                headers.set('content-type', null);
                headers.set('Accept', 'multipart/form-data');
                headers.set('user_sid', userid)
                let b = this.http.post(APIConstants.VERIFYOTPENTITYPETM, data, { headers });
                return b;
            }
        
            public tataentityRegistration(data): Observable<any> {  
                const headers = new HttpHeaders();  
                headers.set('content-type', null);
                headers.set('Accept', 'multipart/form-data');
                return this.http.post(APIConstants.TATAENTITYREGISTER, data, { headers });
            }
            public tatalogin(data): Observable<any> {
                const headers = new HttpHeaders();  
                headers.set('content-type', null);
                headers.set('Accept', 'multipart/form-data');
                let a= this.http.post<any>(APIConstants.TATALOGINMONGO, data, { headers });
                return a;           
            }
            
            logOut(ID: any,URNorEntityID: any){
            
                let a= this.http.get<any>(APIConstants.LOGOUT+'/'+ID+'/'+URNorEntityID);
                return a;
            }

            //PE TM BInding - UTM Side
        public utmgenerateOTP(data): Observable<any> {
            const headers = new HttpHeaders();
            headers.set('content-type', null);
            headers.set('Accept', 'multipart/form-data');        
            let b= this.http.post(APIConstants.UTMGENERATEOTP, data, { headers });
            return b;
        }
        
           //PE TM BInding - UTM Side            
        public utmverifyOTP(data): Observable<any> {

        let userid = this.db.get(Constants.SESSSION_STORAGE, Constants.USERID_OTP);
            const headers = new HttpHeaders();
            headers.set('content-type', null);
            headers.set('Accept', 'multipart/form-data');
            headers.set('user_sid',userid)      
            
            let b= this.http.post(APIConstants.UTMVERIFYOTP, data, { headers });
            return b;
           
        }

}
